import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { CountryCode } from '@rma/public/generic/util/environment';
import { catchError, map, Observable, of } from 'rxjs';

interface VisitorRegionResponse {
  country: CountryCode | null;
}

@Injectable({
  providedIn: 'root',
})
export class VisitorRegionApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getCountry(): Observable<CountryCode | null> {
    return this.httpClient.get<VisitorRegionResponse>(this.rmaApiUrl('Visitor/Region')).pipe(
      map((response) => response.country),
      catchError(() => of(null)),
    );
  }
}
